import { Timestamp } from 'firebase/firestore';

export type Role = 'owner' | 'user' | 'manager'

export const roleLabels: Record<Role, string> = {
  owner: 'Owner',
  user: 'User',
  manager: 'Manager',
};

export type Permission = 'all' | 'editor' | 'roomServiceManager' | 'rentalManager' | 'reportManager' | 'spaManager' | 'storeManager';

export const permissionLabels: Record<Permission, string> = {
  all: 'All permissions',
  editor: 'Editor',
  roomServiceManager: 'Room Service Manager',
  rentalManager: 'Rental Manager',
  reportManager: 'Report Manager',
  spaManager: 'SPA Manager',
  storeManager: 'Store Manager',
};

export type StaffServicePermission = 'reports' | 'roomservice' | 'store' | 'rental' | 'qrscanner' | 'rooms';

export const staffServicePermissionLabels: Record<StaffServicePermission, string> = {
  reports: 'Reports',
  roomservice: 'Room Service',
  store: 'Store',
  rental: 'Rental',
  qrscanner: 'Skaner Kodów',
  rooms: 'Pokoje',
};

export interface RentalVisibilityDocument {
    rentalVisible: boolean;
}

export interface UserEmailFirebaseCreateRequest {
    email: string;
    name?: string;
    surname?: string;
    phoneNumber?: string;
    organization?: string;
    role: Role[];
    permissions?: Permission[];
    staffService?: boolean;
    staffServicePermissions?: StaffServicePermission[];
}

export interface UserDataFirebaseCreateRequest {
    email: string;
    name?: string;
    surname?: string;
    phoneNumber?: string;
    organization: string;
    role: Role[];
    permissions?: Permission[];
    staffService?: boolean;
    staffServicePermissions?: StaffServicePermission[];
    language?: string;
}

export interface UserDataFirebaseResponse {
    id: string;
    email: string;
    name?: string;
    surname?: string;
    phoneNumber?: string;
    createdAt?: Timestamp;
    associated_organization?: string;
    organizations?:string[];
    role?: Role[];
    permissions?: Permission[];
    staffService?: boolean;
    staffServicePermissions?: StaffServicePermission[];
    /** Konto techniczne ekranu KDS, nie człowiek — patrz `useGetTeamMembers`. */
    isKdsDevice?: boolean;
}
